import { render, staticRenderFns } from "./CareProtocol.vue?vue&type=template&id=93790a4a&scoped=true&"
import script from "./CareProtocol.vue?vue&type=script&lang=js&"
export * from "./CareProtocol.vue?vue&type=script&lang=js&"
import style0 from "./CareProtocol.vue?vue&type=style&index=0&id=93790a4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93790a4a",
  null
  
)

export default component.exports